var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 309,
    height: 144,
    viewBox: "0 0 309 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M211.874 143.747C95.0493 143.747 0 61.259 0 -40.1265C0 -141.512 95.0493 -224 211.874 -224V-221.707C96.5059 -221.707 2.66632 -140.248 2.66632 -40.1479C2.66632 59.9734 96.5306 141.412 211.874 141.412C246.733 141.412 281.247 133.827 311.663 119.472L312.922 121.486C282.111 136.077 247.153 143.747 211.874 143.747Z",
    fill: "white",
    fillOpacity: 0.11
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.613 101.41C54.5345 70.8999 20.4648 17.979 20.4648 -40.127H25.7728C25.7728 16.3721 58.9042 67.8147 114.403 97.489L111.613 101.41Z",
    fill: "white",
    fillOpacity: 0.11
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M211.875 126.007C190.89 126.007 170.275 123.072 150.574 117.308L152.278 112.959C171.436 118.572 191.482 121.422 211.899 121.422C307.764 121.422 387.383 59.0951 397.036 -23.5645L402.319 -23.0931C392.345 61.8804 310.479 126.007 211.875 126.007Z",
    fill: "white",
    fillOpacity: 0.11
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M211.875 79.8557C135.638 79.8557 73.6211 26.0348 73.6211 -40.1271C73.6211 -66.9089 83.5704 -92.2338 102.358 -113.359L106.555 -110.553C88.4833 -90.2199 78.929 -65.8805 78.929 -40.1271C78.929 23.4852 138.576 75.2492 211.875 75.2492C224.885 75.2492 237.748 73.6208 250.067 70.407L251.598 74.8207C238.76 78.1845 225.379 79.8557 211.875 79.8557Z",
    fill: "white",
    fillOpacity: 0.11
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M305.242 48.3604L301.662 44.9751C329.091 23.164 344.817 -7.8387 344.817 -40.1055C344.817 -62.8165 337.213 -84.7991 322.844 -103.675L327.264 -106.203C342.225 -86.5774 350.125 -63.7164 350.125 -40.0841C350.1 -6.55321 333.757 25.6922 305.242 48.3604Z",
    fill: "white",
    fillOpacity: 0.11
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M211.874 59.2452C193.259 59.2452 174.767 55.2815 158.424 47.7825L159.658 45.7472C175.631 53.0747 193.678 56.9526 211.849 56.9526C262.04 56.9526 306.38 27.664 319.687 -14.2871L322.23 -13.6658C308.651 29.2709 263.25 59.2452 211.874 59.2452Z",
    fill: "white",
    fillOpacity: 0.11
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M130.92 30.1705C109.293 11.4017 97.3691 -13.5589 97.3691 -40.1051C97.3691 -94.8901 148.72 -139.477 211.873 -139.477C275 -139.477 326.376 -94.8901 326.376 -40.1051H323.735C323.735 -93.626 273.568 -137.163 211.897 -137.163C150.226 -137.163 100.06 -93.626 100.06 -40.1051C100.06 -14.1803 111.688 10.2019 132.846 28.5422L130.92 30.1705Z",
    fill: "white",
    fillOpacity: 0.11
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M211.876 21.6866C172.597 21.6866 140.65 -6.03797 140.65 -40.1259C140.65 -74.2139 172.597 -101.938 211.876 -101.938V-97.3319C175.535 -97.3319 145.958 -71.6642 145.958 -40.1259C145.958 -8.5876 175.535 17.0802 211.876 17.0802C248.217 17.0802 277.793 -8.5876 277.793 -40.1259H283.101C283.076 -6.03797 251.13 21.6866 211.876 21.6866Z",
    fill: "white",
    fillOpacity: 0.11
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.92d9fe653f4d6e22bc9baaa2c61cc592.svg";
export { ForwardRef as ReactComponent };